import React, { useState } from 'react';

import { Select, SelectProps } from 'antd';

import { useGroupsQuery } from './hooks/useGroupsQuery';

interface IOption {
  label: string;
  value: string;
}
interface IProps extends SelectProps {
  placeholder: string;
  mode?: 'multiple' | 'tags';
  initialOptions?: IOption[];
  disabledOptions?: string[];
  labelInValue?: boolean;
}

export const GroupsSelect: React.FC<IProps> = ({
  placeholder,
  initialOptions = [],
  disabledOptions = [],
  mode,
  labelInValue = false,
  ...props
}) => {
  const { data, hasNextPage, fetchNextPage, isFetching } = useGroupsQuery({
    size: 10,
  });
  const [options, setOptions] = useState<IOption[]>(initialOptions);

  React.useEffect(() => {
    setOptions(
      data?.pages.flatMap((page) =>
        page.items?.map((el) => ({
          label: `${el.name}`,
          value: el.uid,
          disabled: disabledOptions.some((uid) => uid === el.uid),
        }))
      ) || []
    );
  }, [data]);

  return (
    <Select
      allowClear
      mode={mode}
      labelInValue={labelInValue}
      placeholder={placeholder}
      options={options}
      onPopupScroll={(e: any) => {
        const { target } = e;
        if (target?.scrollTop + 10 + target?.offsetHeight > target?.scrollHeight && hasNextPage && !isFetching) {
          fetchNextPage();
        }
      }}
      {...props}
    />
  );
};
